import React, { useEffect, useState, useContext } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import CardHeader from "@mui/material/CardHeader";
import { useLocation } from "react-router-dom";
import SearchDayBar from "../../AppointmentDays/SearchDayBar";
import AppointmentsApi from "../../../../Classes/API/Appointments/AppointmentsApi";
import GetAppointmentDayReq from "../../../../Classes/Models/Requests/Appointments/GetAppointmentDayReq";
import Swal from "sweetalert2";
import { LanguageContext } from "App";
import DayToBeCopied from "./DayToBeCopied";
import "./AppDay.scss";
const CopyDayCard = ({ CurrentDay, setAppDay, GetAppDayById }) => {
  const { state } = useLocation();
  const [IsLoaded, setIsLoaded] = useState(false);
  const { translations } = useContext(LanguageContext);
  const [SearchedDay, setSearchedDay] = useState({});

  const GetAppDay = async (DayInput) => {
    let req = new GetAppointmentDayReq();
    req.dateDay = DayInput;

    let res = await AppointmentsApi.GetAppoinmentDayByDate(req);

    if (res.status == "Success") {
      setSearchedDay(res.data);
    } else {
      Swal.fire("Failed", res.message, "error");
    }
  };

  useEffect(() => {
    if (Object.keys(SearchedDay).length > 0) {
      setIsLoaded(true);
    }
  }, [SearchedDay]);

  return (
    <div className="card-container">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CardHeader title={translations.appointmentTablecopycard} />
        <SearchDayBar GetAppDay={GetAppDay} />
        {IsLoaded ? (
          <DayToBeCopied
            AppDay1={SearchedDay}
            AppDay2={CurrentDay}
            GetAppDayById={GetAppDayById}
          />
        ) : (
          <span></span>
        )}
      </div>
    </div>
  );
};

export default CopyDayCard;
